// extracted by mini-css-extract-plugin
export default {"tre":"styles_tre__BUIXS","select":"styles_select__akHxX"};